import { jsxs as f, jsx as o } from "react/jsx-runtime";
import { E as u, S as v } from "./icons.types-0722eef5.js";
function w({ title: r, titleId: s, size: c, width: t, height: i, extended: l = !1, ...n }) {
  const a = l ? u : v, h = c ? a[c] : t || a[l ? "s" : "l"], e = c ? a[c] : i || a[l ? "s" : "l"];
  return /* @__PURE__ */ f(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 32 32",
      width: h,
      height: e,
      "aria-labelledby": s,
      ...n,
      children: [
        r ? /* @__PURE__ */ o("title", { id: s, children: r }) : null,
        /* @__PURE__ */ o(
          "path",
          {
            fill: "currentColor",
            d: "M15.246 22.667V21.05c-.7-.148-1.275-.43-1.729-.844-.453-.414-.788-1.015-1.004-1.804l1.433-.56c.194.595.465 1.043.812 1.344.347.302.82.453 1.42.453.496 0 .913-.115 1.25-.345.338-.23.507-.57.507-1.025a1.3 1.3 0 0 0-.466-1.018c-.311-.273-.851-.525-1.621-.756-1.114-.334-1.884-.751-2.308-1.251a2.55 2.55 0 0 1-.636-1.695c0-.762.24-1.363.719-1.803.479-.44 1.02-.725 1.623-.856V9.333h1.55v1.558c.514.073.99.291 1.431.654.44.362.764.814.972 1.353l-1.419.632a2.422 2.422 0 0 0-.643-.863c-.27-.229-.637-.343-1.098-.343-.482 0-.867.117-1.154.352-.288.234-.431.501-.431.802 0 .371.13.667.388.889.26.221.913.5 1.962.835.888.27 1.563.663 2.024 1.178.462.515.68 1.137.657 1.868-.024.872-.287 1.538-.787 1.997-.501.46-1.135.747-1.902.864v1.558h-1.55Z"
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            fill: "currentColor",
            d: "M16.244 27.333c2.68 0 5.045-.82 7.094-2.46 2.049-1.64 3.361-3.731 3.937-6.273a.807.807 0 0 0-.143-.731.963.963 0 0 0-.678-.387 1.026 1.026 0 0 0-.726.162 1.126 1.126 0 0 0-.453.633c-.508 2.06-1.601 3.75-3.28 5.073-1.68 1.322-3.597 1.983-5.75 1.983-2.6 0-4.806-.905-6.617-2.716C7.817 20.806 6.91 18.6 6.91 16c0-2.6.906-4.806 2.717-6.617 1.81-1.81 4.016-2.716 6.616-2.716 1.457 0 2.822.323 4.095.97a10.077 10.077 0 0 1 3.29 2.67h-2.487a.968.968 0 0 0-.713.288.969.969 0 0 0-.287.713c0 .284.096.521.287.713.192.19.43.287.713.287h4.564c.341 0 .628-.116.858-.347.232-.23.347-.517.347-.858V6.539a.968.968 0 0 0-.288-.713.968.968 0 0 0-.712-.287.967.967 0 0 0-.713.287.968.968 0 0 0-.287.713v2.159a11.317 11.317 0 0 0-3.887-2.974 11.158 11.158 0 0 0-4.78-1.057c-1.573 0-3.046.297-4.42.892a11.477 11.477 0 0 0-3.595 2.426 11.477 11.477 0 0 0-2.426 3.594c-.594 1.374-.892 2.847-.892 4.42s.298 3.047.892 4.422a11.475 11.475 0 0 0 2.426 3.594 11.476 11.476 0 0 0 3.594 2.426c1.374.595 2.848.892 4.421.892Z"
          }
        )
      ]
    }
  );
}
export {
  w as AutoPay
};
